// Transitions Language
import { createI18n } from 'vue-i18n';

import customRuleForArabic from '@/locale/customPluralization';
import ar from '@/locale/langs/ar/index';
import en from '@/locale/langs/en/index';
export const messages = {
  en,
  ar,
};

export const pluralizationRules = {
  ar: customRuleForArabic,
  en(choice: number) {
    if (choice === 0) {
      return 0;
    }
    if (choice === 1) {
      return 1;
    }
    return 2;
  },
};

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  legacy: false,
  globalInjection: true,
  silentTranslationWarn: true,
  messages,
  pluralizationRules,
});

export default i18n;
